import React from 'react';
import { videoTestimonials } from '../data/mock';
import { Star } from 'lucide-react';

const AVATAR_COLORS = [
  'from-purple-600 to-blue-600',
  'from-teal-500 to-emerald-600',
  'from-amber-500 to-orange-600',
  'from-pink-500 to-rose-600',
  'from-indigo-500 to-violet-600',
  'from-cyan-500 to-blue-500',
];

const Testimonials = () => {
  return (
    <section className="py-20 px-6" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto">
        {/* Section header */}
        <div className="text-center mb-14">
          <p className="text-teal-400 text-sm font-semibold tracking-widest uppercase mb-3">
            Trusted by Growing Businesses
          </p>
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
            What Our Customers Say
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto text-base">
            From cleaning companies to law firms, businesses across industries rely on Miadesk to never miss a call again.
          </p>
        </div>

        {/* Testimonials grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {videoTestimonials.map((t, i) => (
            <div
              key={t.id}
              className="bg-[#0d1f35]/60 border border-white/[0.06] rounded-2xl p-6 flex flex-col hover:border-purple-500/20 transition-all duration-300 group"
              data-testid={`testimonial-card-${t.id}`}
            >
              {/* Stars */}
              <div className="flex gap-0.5 mb-4">
                {Array.from({ length: 5 }).map((_, si) => (
                  <Star
                    key={si}
                    className={`w-4 h-4 ${si < t.rating ? 'text-amber-400 fill-amber-400' : 'text-gray-700'}`}
                  />
                ))}
              </div>

              {/* Quote */}
              <p className="text-gray-300 text-sm leading-relaxed flex-1 mb-5">
                "{t.quote}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-3 pt-4 border-t border-white/5">
                <div className={`w-10 h-10 rounded-full bg-gradient-to-br ${AVATAR_COLORS[i % AVATAR_COLORS.length]} flex items-center justify-center flex-shrink-0`}>
                  <span className="text-white font-semibold text-sm">
                    {t.name.split(' ').map(n => n[0]).join('').slice(0, 2)}
                  </span>
                </div>
                <div className="min-w-0">
                  <p className="text-white font-medium text-sm truncate">{t.name}</p>
                  <p className="text-gray-500 text-xs truncate">
                    {t.title}, {t.company}
                  </p>
                </div>
                <span className="ml-auto bg-white/5 text-gray-400 text-[10px] font-medium px-2 py-1 rounded-full flex-shrink-0">
                  {t.industry}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
